// src/components/PrivateRoute.jsx
import React from "react";

import { getCookie } from "cookies-next";
import { nonToken } from "../config";

const PrivateRoute = ({ children }) => {
  const token = getCookie("tokenC");

  if (!token) {
    return nonToken();
  }

  return children;
};

export default PrivateRoute;
